import React from "react";

const Documentation: React.FC = () => {
  return (
    <div style={{ width: "100%", height: "calc(100dvh - 70px)" }}>
      <iframe
        src="https://postchat.zhheo.com/postChat.html"
        title="PostChat Documentation"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
      />
    </div>
  );
};

export default Documentation;
